import {
  GET_ENTERPRISE_SCANNED_IMAGE,
  GET_ENTERPRISE_SCANNED_IMAGE_SUCCESS,
  GET_ENTERPRISE_SCANNED_IMAGE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getEnterpriseScannedImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENTERPRISE_SCANNED_IMAGE:
      return { ...state, loading: true };
    case GET_ENTERPRISE_SCANNED_IMAGE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_ENTERPRISE_SCANNED_IMAGE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getEnterpriseScannedImageReducer;
